import { ComponentType } from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';

import Headerbar from '@src/components/Headerbar';
import { UiRoutes } from '@src/lib/constants';
import { ReduxProps } from '@src/redux/type';

import { StyledContainer, StyledContent, StyledHeader } from './style';

const PrivateRoute = ({ component: Component }: { component: ComponentType }) => {
  const { isUserAuthenticated } = useSelector((state: ReduxProps) => state?.loginReducer?.loginState);

  return isUserAuthenticated ? (
    <StyledContainer>
      <StyledContent>
        <StyledHeader>
          <Headerbar />
        </StyledHeader>
        <div style={{ display: 'flex', height: 'calc(100% - 65px)', flexDirection: 'column' }}>
          <Component />
        </div>
      </StyledContent>
    </StyledContainer>
  ) : (
    <Navigate to={UiRoutes.LOGIN} replace />
  );
};

export default PrivateRoute;
